import { render, staticRenderFns } from "./DoughnutGraph.vue?vue&type=template&id=42ec6ff2"
import script from "./DoughnutGraph.vue?vue&type=script&lang=ts"
export * from "./DoughnutGraph.vue?vue&type=script&lang=ts"
import style0 from "./DoughnutGraph.vue?vue&type=style&index=0&id=42ec6ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports